import { type ScheduleTimeSlot } from '@/features/plants/schemas/schedule-plant.schema.ts';

export const convertTimeToMinutes = (time: string): number => {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
};

export const convertMinutesToTimeString = (totalMinutes: number): string => {
  const clampedMinutes = Math.max(0, Math.min(24 * 60, totalMinutes));
  const hours = Math.floor(clampedMinutes / 60);
  const minutes = clampedMinutes % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

export const sortTimeSlotsByStartTime = (
  timeSlots: ScheduleTimeSlot[]
): ScheduleTimeSlot[] => {
  return [...timeSlots].sort(
    (a, b) => convertTimeToMinutes(a.startTime) - convertTimeToMinutes(b.startTime)
  );
};
